import { ReactNode } from 'react';

import { BookingDetailPaymentInfoView } from '@mopla/data-models';
import { getActualPrice } from '@mopla/utils';

import { defaultRenderer } from './defaultRenderer';
import { IPriceStringProps, PriceString } from './PriceString';

export interface IPaymentBlockProps<
	T extends { payment?: BookingDetailPaymentInfoView }
> {
	entity: T | null;
	single?: boolean;
	render?: (paymentString: ReactNode) => ReactNode;
	renderPaymentParts?: IPriceStringProps['render'];
	totalCancellationPrice?: number;
	isCancelled?: boolean;
}

export const PaymentBlock = <
	T extends { payment?: BookingDetailPaymentInfoView }
>({
	entity,
	single,
	render = defaultRenderer,
	renderPaymentParts,
	totalCancellationPrice,
	isCancelled = false,
}: IPaymentBlockProps<T>) => {
	if (!entity?.payment) {
		return null;
	}

	const currentPrice = getActualPrice(entity.payment);
	const showPreviousPrice = !!entity.payment.overwrittenPaymentAmount;
	const previousPrice = showPreviousPrice
		? entity.payment.paymentAmount
		: isCancelled && totalCancellationPrice
		? currentPrice
		: undefined;

	const price = isCancelled ? totalCancellationPrice : currentPrice;
	const strikethroughPrice =
		price === previousPrice ? undefined : previousPrice;

	return (
		<>
			{render(
				<PriceString
					price={price}
					hasPriceTariff={!entity.payment.paymentInformationAvailable}
					single={single}
					previousPrice={strikethroughPrice}
					render={renderPaymentParts}
				/>
			)}
		</>
	);
};
